import React from 'react';
import PropTypes from 'prop-types';

const FeeTip = ({ i18n, commissionStatus, bnbAmount }) => {
  if (commissionStatus === 0) {
    return (
      <span>
        {i18n.BNBpaymentNotOpen || 'Not using BNB for fees'}
      </span>);
  } if (commissionStatus === 1) {
    if (bnbAmount >= 1) {
      return (
        <span>
          {i18n.BNBpayment || 'Using BNB for fees'}
        </span>);
    } if (bnbAmount > 0) {
      return (
        <span>
          {i18n['BNB funds low'] || 'BNB funds low'}
        </span>);
    }
    return (
      <span>
        {i18n['No BNB available'] || 'No BNB available'}
      </span>);
  }
  return null;
};

FeeTip.propTypes = {
  i18n: PropTypes.object.isRequired,
  commissionStatus: PropTypes.number.isRequired,
  bnbAmount: PropTypes.string.isRequired,
};

export default FeeTip;
